import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service'

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.css']
})
export class TransactionsComponent implements OnInit {

  options = [
    { label: "School Invoices", value: 3 },
    { label: "Payment received", value: 1 },
    { label: "Payment to School", value: 4},
    { label: "Export CSV or XLSX for VAT", value: 2 }
  ];

  selectedOption = 3;

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {
  }

}
